import React from "react";
import { Arrow, useMarketingCopy } from "./MarketingShell";
import outcomesCopy from "./businessOutcomesCopy.json";
import "./BusinessOutcomes.css";

export default function BusinessOutcomes({ compact = false }: { compact?: boolean }) {
  const { language } = useMarketingCopy();
  const copy = outcomesCopy[language] ?? outcomesCopy.en;
  return <section id="why-youwo" className="quant-wrap business-outcomes" aria-labelledby="outcomes-title">
    <div className="outcomes-intro">
      <p className="outcomes-label">{copy.label}</p>
      <h2 id="outcomes-title">{copy.title}<br /><em>{copy.accent}</em></h2>
      <p className="outcomes-description">{copy.description}</p>
      <ul className="outcomes-measures" aria-label={copy.label}>
        {copy.measures.map(measure => <li key={measure}>{measure}</li>)}
      </ul>
    </div>
    <div className="outcomes-detail">
      <ol className="outcomes-commitments">
        {copy.points.map((point,index) => <li key={point.title}>
          <span aria-hidden="true">0{index + 1}</span><div><h3>{point.title}</h3>{!compact && <p>{point.text}</p>}</div>
        </li>)}
      </ol>
      <p className="outcomes-comparison">{copy.comparison}</p>
      <a href="/blog/business-outcomes-from-day-one" className="quant-text-link">{copy.link}<Arrow /></a>
    </div>
  </section>;
}
